import styled from '@emotion/styled'
import { SEO } from 'app/components/SEO'
import {
  Props as StructuredDataProps,
  StructuredData,
} from 'app/components/StructuredData'
import { Footer, Props as FooterProps } from 'app/containers/Footer'
import { Header, Props as HeaderProps } from 'app/containers/Header'
import { QuotationForm } from 'app/containers/QuotationForm'
import {
  QuotationFormSenderBackend,
  QuotationFormSenderBackendConfiguration,
} from 'app/utils/QuotationFormSender'
import { PageProps } from 'gatsby'
import React, { memo, useMemo } from 'react'

import { Props } from './contents'

export interface PageContext {
  id: string
  languageCode: string
  languagePrefix: string | null
  headerProps?: HeaderProps
  footerProps?: FooterProps
  structuredDataProps?: StructuredDataProps
  quotationFormSenderBackendConfiguration: QuotationFormSenderBackendConfiguration
}

export interface Context extends PageContext {
  props: Props
}

export default memo(function QuotationPageTemplate({
  pageContext,
}: PageProps<void, Context>) {
  const context = pageContext as any

  const sendFormToBackend = useMemo(
    () =>
      QuotationFormSenderBackend(
        pageContext.quotationFormSenderBackendConfiguration,
      ),
    [pageContext.quotationFormSenderBackendConfiguration],
  )

  return (
    <Container>
      <SEO {...context.seoProps} />
      {context.structuredDataProps ? (
        <StructuredData
          languageCode={pageContext.languageCode}
          {...context.structuredDataProps}
        />
      ) : null}
      {context.headerProps ? (
        <Header
          pageID={context.id}
          languageCode={context.languageCode}
          languagePrefix={context.languagePrefix}
          variant="compact"
          {...context.headerProps}
        />
      ) : null}
      {context.formProps ? (
        <QuotationForm
          {...context.formProps}
          onQuotationFormSendToBackend={async (data) =>
            await sendFormToBackend(data)
          }
        />
      ) : null}
      {context.footerProps ? (
        <Footer languageCode={context.languageCode} {...context.footerProps} />
      ) : null}
    </Container>
  )
})

const Container = styled.main``
